import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    const hash = window.location.hash
    if (!hash || !/^#[\w-]+$/.test(hash)) return

    const triggerEl = this.element.querySelector(`[href="${hash}"]`)
    if (!triggerEl) return

    bootstrap.Tab.getOrCreateInstance(triggerEl).show()
  }

  updateUrl(event) {
    history.replaceState(null, '', event.target.getAttribute('href'))
  }
}
